/**
 * Created by jv on 2019-10-01 (14:21).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");
import EventPanel from "Sources/components/game/components/event-panel";

require("Styles/components/business-model-dialog.scss");
require("Styles/components/event-dialog.scss");

class EventDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("event-dialog-");

    this._event = options.event;

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
  }

  get event() {
    return this._event;
  }

  set event(event) {
    this._event = event;
    this.renderDialogContent();
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.eventPanel = new EventPanel();

      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog event-dialog'>" +
      "<div class='modal-content'>" +
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    if (utils.isNull(this.event)) return;

    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up event dialog for event - %o", this.event);

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      this.eventPanel.appendTo = $dialogContent;
      this.eventPanel.event = this.event;

      this.setUpCloseRoundEventListeners();
    }
  }

  show() {
    this.$dialog.modal("show");
  }

  hide() {
    this.$dialog.modal("hide");
  }

  setUpDialogEventListeners() {

  }

  setUpCloseRoundEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });
  }
}

export default EventDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/event-dialog.js